import { render, staticRenderFns } from "./OrticWizard.vue?vue&type=template&id=1939c36b&scoped=true&"
import script from "./OrticWizard.vue?vue&type=script&lang=js&"
export * from "./OrticWizard.vue?vue&type=script&lang=js&"
import style0 from "./OrticWizard.vue?vue&type=style&index=0&id=1939c36b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1939c36b",
  null
  
)

export default component.exports